import db from "@/libs/utils/db";
export default {
    namespaced: true,
    state: {
        menu : []
    },
    actions: {
        get ({ state }) {
            return new Promise(async resolve => {
                db.getStorageSync("adminMenu");
                state.menu =  value;
                resolve();
            });
        },
        set({ state, dispatch }, info) {
            state.menu = info;
            db.setStorageSync("adminMenu",info);
        }
    }
}
